import moment from 'moment'

// a file's extension, lower case ("" when it has none)
const ext = (file) => ((file.orig_filename || '').match(/\.([a-z0-9]+)$/i) || [])[1]?.toLowerCase() || ''

/** The icon for a file's type, and its colour (a Bootstrap text colour). */
export function fileIcon(file) {
  const mime = (file.mime_type || file.file_extension || '').toLowerCase()
  const e = ext(file)
  if (file.is_image || mime.startsWith('image/')) return {icon: ['far', 'image'], color: 'secondary'}
  if (mime.includes('pdf') || e === 'pdf') return {icon: ['far', 'file-pdf'], color: 'danger'}
  if (mime.includes('spreadsheet') || mime.includes('excel') || mime.includes('csv') || ['xls', 'xlsx', 'ods', 'csv'].includes(e)) return {icon: ['far', 'file-excel'], color: 'success'}
  if (mime.includes('wordprocessing') || mime.includes('msword') || mime.includes('opendocument.text') || ['doc', 'docx', 'odt', 'rtf'].includes(e)) return {icon: ['far', 'file-word'], color: 'primary'}
  if (mime.includes('presentation') || ['ppt', 'pptx', 'odp'].includes(e)) return {icon: ['far', 'file-powerpoint'], color: 'warning'}
  if (mime === 'message/rfc822' || e === 'eml') return {icon: ['far', 'envelope'], color: 'info'}
  if (mime.includes('zip') || ['zip', '7z', 'rar', 'gz'].includes(e)) return {icon: ['far', 'file-zipper'], color: 'secondary'}
  if (mime.startsWith('text/') || ['txt', 'html', 'htm', 'json', 'xml'].includes(e)) return {icon: ['far', 'file-lines'], color: 'secondary'}
  return {icon: ['far', 'file'], color: 'secondary'}
}

/** What the document scan read about who, which and when: "Thermo Fisher · #948213 · May 14, 2026" */
export function scanLine(file) {
  const s = file.scan
  if (!s || s.kind !== 'document')
    return ''
  return [s.from, s.reference ? '#' + s.reference : null, s.date ? moment(s.date).format('MMM D, YYYY') : null].filter(Boolean).join(' · ')
}

/** The tab a file falls under in a record's file list: its document type, Photos, or Other. */
export function fileGroup(file) {
  if (file.scan?.doc_type_desc) return file.scan.doc_type_desc
  if (file.is_image) return 'Photos'
  return 'Other'
}
